import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { NavigateLink } from '@/common/components/links/NavigateLink';
import Icon from '@/common/components/Icon';
import { Colors } from '@/common/colors/colors';
import { formatPhoneNumber } from '@/common/functions/formatPhoneNumber';

const IconsWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${Colors.darkBlue};
	gap: 10px;
`;

const THead = styled.thead`
	th {
		background-color: #c48acd;
	}
`;

const TBody = styled.tbody`
	td {
		background-color: #ffefd0;
	}
`;

export const WraptimeNow = ({ data = [] }) => {
	return (
		<table
			className='styled-table'
			style={{ minWidth: '650px', maxWidth: '650px' }}
		>
			<THead>
				<tr>
					<th colSpan={6}>Wraptime Users</th>
				</tr>
				<tr>
					<th>Id</th>
					<th>Username</th>
					<th>Number</th>
					<th>Answered at</th>
					<th>Wrap at</th>
					<th>Actions</th>
				</tr>
			</THead>
			<TBody className='queue'>
				{data.length > 0 ? (
					data
						.sort(
							(a, b) =>
								new Date(b.talking_end).getTime() -
								new Date(a.talking_end).getTime(),
						)
						.map((element, i) => (
							<tr key={i}>
								<td>{i + 1}</td>
								<td>{element.username}</td>
								<td>
									{element?.phone_number &&
										formatPhoneNumber(element?.phone_number)}
								</td>
								<td>{moment(element.talking_at).format('DD/MM HH:mm:ss')}</td>
								<td>
									{element.talking_end_at
										? moment(element.talking_end_at).format('DD/MM HH:mm:ss')
										: '-------'}
								</td>
								<td>
									<IconsWrapper>
										<NavigateLink
											target='_blank'
											to={`/settings/user/list?mode=show&userId=${element.consultant}`}
										>
											<Icon name='user' />
										</NavigateLink>
										<NavigateLink
											target='_blank'
											to={`/dashboard/contact/${element.contact}`}
										>
											<Icon name='address-book' />
										</NavigateLink>
										<NavigateLink
											target='_blank'
											to={`/dashboard/order/${element.order}`}
										>
											<Icon name='address-card' />
										</NavigateLink>
									</IconsWrapper>
								</td>
							</tr>
						))
				) : (
					<tr>
						<td colSpan={6}>There is no users</td>
					</tr>
				)}
			</TBody>
		</table>
	);
};
